export default __webpack_public_path__ + "static/media/yellow-user-icon.1df76ccb.svg";